module.exports = __webpack_public_path__ + "img/prowess.08bcaf7c.svg";